const compatModules = {};import * as Mod1 from "./discourse/connectors/category-custom-settings/waze-bot-authors-settings.gjs";
compatModules["discourse/connectors/category-custom-settings/waze-bot-authors-settings"] = Mod1;

export * as discourse$connectors$category__custom__settings$waze__bot__authors__settings$$__module from "./discourse/connectors/category-custom-settings/waze-bot-authors-settings.gjs";
export {
default as discourse$connectors$category__custom__settings$waze__bot__authors__settings$$default
} from "./discourse/connectors/category-custom-settings/waze-bot-authors-settings.gjs";
import * as Mod2 from "./discourse/placeholder";
compatModules["discourse/placeholder"] = Mod2;

export * as discourse$placeholder$$__module from "./discourse/placeholder";
export {

} from "./discourse/placeholder";
export default compatModules;
